// extracted by mini-css-extract-plugin
export default {"SectionArticles":"SectionArticles_SectionArticles__iLUWt","inner":"SectionArticles_inner__n+A2s","list":"SectionArticles_list__nUMFL","buttons":"SectionArticles_buttons__-NtJk"};